import { commonFilterOptions } from 'utils/dateRangeFilterOptions';

export const ACTIVITY_PANEL_DEFAULT_DATE = commonFilterOptions.ALL_DATES.value;

export const ACTIVITY_PANEL_DEFAULT_FILTERS = {
  dateRange: {
    type: ACTIVITY_PANEL_DEFAULT_DATE,
  },
  requestId: '',
  stepId: '',
  requestStatus: [],
  flowTrigger: [],
};
